import { Component, Input } from '@angular/core';
import { LoggerService, LogCategory, LogType, LogCoreComponent } from 'src/app/core/services/logger.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProfileService } from '../../services/profile.service';

@Component({
    selector: 'concentrations-modal',
    templateUrl: './concentrations.component.html',
    styleUrls: ['./concentrations.component.scss'],
    standalone: false
})
export class ConcentrationsModalComponent {

    @Input() type: string;
    @Input() numConc: number;

    constructor(
        private logger: LoggerService,       
        public activeModal: NgbActiveModal,
        public profileService: ProfileService,
    ) {
        this.log("constructor", "", LogCategory.Constructor);
    }
          
    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.CoreComponent, LogCoreComponent.ModalError, category);
    }
   
}
